import React from 'react';
import { motion } from 'framer-motion';

// Subtle page-level fade + lift. Keep the duration short so navigation feels
// snappy, not draggy.
export default function PageTransition({ children }) {
  return (
    <motion.main
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -8 }}
      transition={{ duration: 0.45, ease: [0.16, 0.84, 0.44, 1] }}
    >
      {children}
    </motion.main>
  );
}
